import { motion } from "framer-motion";
import React from "react";

export default function MotionAppear({ children,
    offY = 30,
    amount = 0.2,  // % visible on screen
    style = {},
}) {
    const cardVariants = {
        offscreen: {
            y: offY,
            opacity: 0,
        },
        onscreen: {
            y: 0,
            opacity: 1,
            transition: {
                type: "spring",
                bounce: 0.4,
                duration: 1.8,
            },
        },
    };

    return (
        <motion.div
            initial="offscreen"
            whileInView="onscreen"
            viewport={{ once: true, amount, }}
            variants={cardVariants}
            style={{ ...style }}
        >
            {children}
        </motion.div>
    );
}
